import { render, staticRenderFns } from "./DocumentSearch.vue?vue&type=template&id=1d730488&scoped=true"
import script from "./DocumentSearch.vue?vue&type=script&lang=js"
export * from "./DocumentSearch.vue?vue&type=script&lang=js"
import style0 from "./DocumentSearch.vue?vue&type=style&index=0&id=1d730488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d730488",
  null
  
)

export default component.exports